import { useRegisterRuleGroup } from './rule-group-registration-context';
export const ButtonRuleGroup = _ref => {
  let {
    children,
    ...ruleGroup
  } = _ref;
  useRegisterRuleGroup(ruleGroup);
  return null;
};
//# sourceMappingURL=button-rule-group.js.map